var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * A recuperacao de senha, nas tres etapas que o backend exige.
 *
 * Um scope so para as tres: sao a mesma conversa, e o e-mail digitado na primeira
 * e o que a terceira envia. Separa-las em tres places pediria guardar e-mail e
 * token em algum lugar entre elas - e nenhum dos dois pode ir para o endereco.
 */
let ForgotPasswordScope = class ForgotPasswordScope extends Scope {
    constructor() {
        super(...arguments);
        this.step = 'email';
        this.email = '';
        this.code = '';
        this.password = '';
        this.confirmPassword = '';
        this.busy = false;
        /** Quanto falta do prazo de tres minutos do codigo, em segundos. */
        this.secondsLeft = 0;
        /** `4:59`, ou `0:00` quando o prazo acabou. */
        this.timer = '0:00';
        /** Ligado quando a senha foi trocada - a tela confirma e oferece a porta. */
        this.done = false;
        this.onEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onCodeChanged = Scope.SYNC_ACTION_STRING;
        this.onPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onConfirmPasswordChanged = Scope.SYNC_ACTION_STRING;
        this.onSubmit = Scope.ASYNC_ACTION;
        this.onResend = Scope.ASYNC_ACTION;
        this.onBack = Scope.ASYNC_ACTION;
        this.onGoToSignIn = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], ForgotPasswordScope.prototype, "step", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "code", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "password", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "confirmPassword", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "busy", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], ForgotPasswordScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "secondsLeft", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "timer", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ForgotPasswordScope.prototype, "done", void 0);
ForgotPasswordScope = __decorate([
    Observable
], ForgotPasswordScope);
export { ForgotPasswordScope };
//# sourceMappingURL=forgot-password.scope.js.map